import React from 'react'
import { Typography, Card } from '../../../_atoms'
import { Stack } from '../../../_layouts'
import { useCandidateChat } from '../CandidateChatContext'
import useTranslation from '../../../shared/TranslationProvider'

/**
 * CallRejected component - displays when coach rejects the chat request
 */
const CallRejected = () => {
  const { t } = useTranslation('coach_chat')
  const {
    deloitteUser = false,
    userCareerDevelopment = false,
    selectedCoach,
    getDarkModeClasses,
  } = useCandidateChat()

  // Determine title based on user type
  const getRejectionTitle = () => {
    if (deloitteUser) {
      return t('call_rejected.advisor_title', {
        defaultValue: 'Advisor Unavailable',
      })
    } else if (userCareerDevelopment) {
      return t('call_rejected.coach_title', {
        defaultValue: 'Coach Unavailable',
      })
    } else {
      return t('call_rejected.coach_title', {
        defaultValue: 'Coach Unavailable',
      })
    }
  }

  // Determine message based on user type and coach name
  const getRejectionMessage = () => {
    const coachName = selectedCoach?.displayName || 'your coach'
    if (deloitteUser) {
      return t('call_rejected.advisor_message', {
        coachName,
        defaultValue:
          'Sorry, {{coachName}} is currently unavailable. Please try another advisor or try again later.',
      })
    } else {
      return t('call_rejected.coach_message', {
        coachName,
        defaultValue:
          'Sorry, {{coachName}} is currently unavailable. Please try another coach or try again later.',
      })
    }
  }

  return (
    <div
      id="call_rejected"
      className="flex h-full w-full items-center justify-center"
    >
      <Card className="mx-auto max-w-md p-6">
        <Stack spacing={4} className="text-center">
          <div>
            <Typography
              variant="h3"
              className={`font-roboto text-xl font-semibold ${getDarkModeClasses('text-cod-gray-900', 'text-white')}`}
            >
              {getRejectionTitle()}
            </Typography>
          </div>
          <div>
            <Typography
              className={`font-roboto text-base ${getDarkModeClasses('text-cod-gray-700', 'text-gray-300')}`}
            >
              {getRejectionMessage()}
            </Typography>
          </div>
        </Stack>
      </Card>
    </div>
  )
}

export default CallRejected
